import { ActionTree } from "vuex";
import { RootState } from "../types";
import { USER_MUTATIONS } from "./mutations";
import { UserState } from "./types";

import { firestore, auth } from '@/firebase'
import { getDoc, doc, updateDoc, getDocs, query, collection, where } from "firebase/firestore";
import { signOut } from "firebase/auth";
import { isParticipantLoginBlocked } from "@/utils/programAccess";

export const LOGIN_BLOCKED_STORAGE_KEY = 'itineraLoginBlocked';

export enum USER_ACTIONS {
  AUTHENTICATE_USER = "AUTHENTICATE_USER",
  SIGNOUT = "SIGNOUT"
}

async function participantHasOnlyArchivedPrograms(userId: string): Promise<boolean> {
  const programs = await getDocs(query(collection(firestore, 'programs'), where('participant', '==', userId)));
  return isParticipantLoginBlocked(programs.docs.map((e) => e.data()));
}

export const actions: ActionTree<UserState, RootState> = {
  async [USER_ACTIONS.AUTHENTICATE_USER]({ commit }) {
    const authUser = auth.currentUser;

    if (!authUser) {
      commit(USER_MUTATIONS.SET_USER, null);
      return;
    }

    try {
      const userRef = doc(firestore, "users", authUser.uid);
      const userDoc = await getDoc(userRef);

      if (userDoc.exists()) {
        if (userDoc.data().type === 'PARTICIPANT' && await participantHasOnlyArchivedPrograms(userDoc.id)) {
          window.sessionStorage.setItem(LOGIN_BLOCKED_STORAGE_KEY, 'archived');
          await signOut(auth);
          commit(USER_MUTATIONS.SET_USER, null);
          return;
        }

        await updateDoc(userRef, { lastLogin: new Date() })
        commit(USER_MUTATIONS.SET_USER, {
          id: userDoc.id,
          ...userDoc.data(),
        });
        return;
      }
    } catch (error) {
      console.error('Failed to load authenticated user profile', error);
    }

    // Auth session without a usable users doc must still clear AUTH_LOADING,
    // otherwise the router retries forever and public pages stay blank.
    commit(USER_MUTATIONS.SET_USER, null);
  },
  async [USER_ACTIONS.SIGNOUT]({ commit }) {
    await signOut(auth);
    commit(USER_MUTATIONS.SET_USER, null);
  }
}
